'use strict';

import { cn } from '@src/utils/ui';

const React = require('react');
const PropTypes = require('prop-types');

export const GovIdVerifiedBadge = ({ className = '' }) => {
    return (
        <img
            src='/assets/images/gov_id_verified.svg'
            alt='Government ID Verified Badge'
            title='Government ID Verified'
            className={cn(className)}
        />
    );
};

GovIdVerifiedBadge.propTypes = {
    className: PropTypes.string
};
